export default __webpack_public_path__ + "static/media/workshop-expiring-icon.fbd4b1f6.svg";